import { useEffect, useState } from "react";
import LogoImage from "../assets/images/logo.png";
import ShowRefereePoints from "./ShowRefereePoints";
import HeaRefereeSideInfo from "./HeadRefereeSideInfo";
import axiosConfig from "./axiosConfig";
import { useQuery } from "react-query";

const HeadReferee = (props) => {
  const [queryRun, setQueryRun] = useState(true);

  let headInfo = [];
  let referees = [];
  let match_state = true;
  async function fetchData() {
    let response = await axiosConfig("get-head-points.php");
    if (response.data.status == 1) {
      headInfo = response.data.headinfo;
      referees = response.data.referees;
      match_state = response.data.match_state;
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const { status, data, error, isFetching } = useQuery(
    "todos",
    async () => {
      const { data } = await axiosConfig.get("get-head-points.php");
      return data;
    },
    {
      refetchInterval: 1000,
      enabled: queryRun,
    }
  );

  // let headInfo = [];
  // let referees = [];
  // let matchState = "true";
  if (status === "success") {
    console.log(data);
    headInfo = data.headinfo;
    referees = data.referees;
    match_state = data.match_state;
  }

  function exitHandle() {
    alert("Exit Handler!");
    //   setQueryRun(false);
    //   localStorage.removeItem("playcode");
    //   props.history.replace("/");
  }

  const title = "فدراسیون ووشو جمهوری اسلامی ایران";
  return (
    <>
      <div className="myNavbar">
        <div className="logo">
          <img src={LogoImage} alt="logo" />
        </div>
        <div className="details">{title}</div>
      </div>
      <div className="container-full">
        <div className="row mt-1 pb-5 text-center" style={{ direction: "rtl" }}>
          {referees.map((p, i) => (
            <ShowRefereePoints
              key={i}
              refereeNo={p.number}
              redPoint={p.redpoint}
              bluePoint={p.bluepoint}
              head_redpoint={p.head_redpoint}
              head_bluepoint={p.head_bluepoint}
              head_total_redpoint={p.head_total_redpoint}
              head_total_bluepoint={p.head_total_bluepoint}
              rounds={{
                roundA: p.round_a_winner,
                roundB: p.round_b_winner,
                roundC: p.round_c_winner,
                totalRound: p.total_winner,
              }}
            />
          ))}
          <HeaRefereeSideInfo totalData={headInfo} />
        </div>
        <div className="row mt-2">
          <p
            className="IRANSansLight"
            style={{
              fontSize: "13px",
              textAlign: "center",
              direction: "rtl",
            }}
          >
            در روبروی هر رانده و برنده نهایی, رنگ مربوط به ورزشکار برنده مشخص
            شده است و در صورت تساوی, رنگ{" "}
            <span className="badge bg-secondary">&nbsp;</span> نمایش داده می
            شود.
          </p>
        </div>
      </div>
    </>
  );
};

export default HeadReferee;
